
import { AxiosError } from "axios";
import useApi, { Model, Query } from "../common/hooks/useApi";
import {
    JsonHubProtocol,
    HubConnectionState,
    HubConnectionBuilder,
    LogLevel,
    HubConnection
} from '@microsoft/signalr';
import { useEffect, useRef, useState } from "react";
import moment from "moment-business-days";

export interface EquipoProcesamientoConectado
{
    nombre:string
    fechaHora:Date
    idConexion:string,
    estado?:{
        status:number,
        dt:Date,
        info:any
    },
    mensajes:ServerMessage[]
}

export interface ServerMessage
{
    device_name:String
    dt:moment.Moment
    text:string
}

export default () => {
    const [devices, setDevices] = useState<EquipoProcesamientoConectado[]>([]);
    const [serverMessages, setServerMessages] = useState<ServerMessage[]>([]);
    const hub = useRef<HubConnectionBuilder>(new HubConnectionBuilder());
    const hubConnection = useRef<HubConnection>(undefined!);

    useEffect(()=>{
        hubConnection.current = hub.current
            .withAutomaticReconnect()
            .withUrl(`${new URL(process.env.REACT_APP_API_URL!).origin}/hubs/equipo-procesamiento`)
            .build()

        
        hubConnection.current.onclose(()=>{
            setDevices([]);
        });
        hubConnection.current.on('ActualizarEquiposProcesamiento',getConnectedDevices);
        //hubConnection.current.on('RespuestaComando', onCommandResponse);
        hubConnection.current.on('MensajesServidor',onServerMessages);
        hubConnection.current.on('EquiposProcesamiento',(devices:EquipoProcesamientoConectado[])=>{
            devices = devices.map(d => ({
                ...d,
                ...{
                    "mensajes":[],
                    "fechaHora":new Date(d.fechaHora),
                    "estado":d.estado ? {
                        ...d.estado,
                        ...{
                            dt:new Date(d.estado.dt)
                        }
                    } : undefined
                }

            }))
            setDevices(devices);
        })
    },[]);

    const connect = async () => {
        await hubConnection.current.start();
        hubConnection.current.send('GetMensajesServidor');
    };
    const disconnect = async () => {
        await hubConnection.current.stop();
    }
    const getConnectedDevices = async () => {
        await hubConnection.current.send('GetEquiposProcesamiento');
    }
    const sendStopAnalysis = async (connectionId:string) => {
        await hubConnection.current.send("EnviarComando",connectionId,"stop-analysis")
    }
    const sendStartAnalisys = async (connectionId:string) => {
        await hubConnection.current.send("EnviarComando",connectionId,"start-analysis")
    }
    const sendGenerateExport =async (connectionId:string) => {
        await hubConnection.current.send("EnviarComando",connectionId,"generate-export")
    }
    /*
    const onCommandResponse = async (command:string, connectionId:string, success:boolean) => {
        console.log("SUCCESS",command, connectionId,success);
    }*/
    const onServerMessages = async (messages:any[],connectionId:string) =>  {
        setServerMessages(messages.map(m => ({...m,...{dt:moment.utc(m.dt).local()}})));
    }

    return {
        connect,
        getConnectedDevices,
        devices,
        serverMessages,
        disconnect,
        sendStopAnalysis,
        sendStartAnalisys,
        sendGenerateExport
    };
}